import { render, staticRenderFns } from "./OrderExchangeConfirm.vue?vue&type=template&id=333315ec&scoped=true"
import script from "./OrderExchangeConfirm.vue?vue&type=script&lang=js"
export * from "./OrderExchangeConfirm.vue?vue&type=script&lang=js"
import style0 from "./OrderExchangeConfirm.vue?vue&type=style&index=0&id=333315ec&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "333315ec",
  null
  
)

export default component.exports